export const translations = {
  pt: {
    // Navigation
    nav: {
      home: 'Início',
      services: 'Serviços',
      pentest: 'Pentest',
      secureDev: 'Desenvolvimento Seguro',
      about: 'Sobre',
      cases: 'Cases',
      blog: 'Blog',
      contact: 'Contato'
    },
    // Hero
    hero: {
      title: 'Segurança desde a primeira linha de código até o deploy final',
      subtitle: 'Websites, aplicações e landing pages seguras, além de testes de intrusão profissionais para proteger seu negócio contra ameaças cibernéticas reais.',
      primaryCTA: 'Solicitar Auditoria de Segurança',
      secondaryCTA: 'Falar com Especialista'
    },
    // Services
    services: {
      title: 'Nossos Serviços',
      subtitle: 'Soluções completas de cibersegurança, testes de intrusão e desenvolvimento de sites e aplicações seguras para proteger seu negócio',
      pentest: {
        title: 'Pentest',
        description: 'Testes de intrusão profissionais para identificar vulnerabilidades antes dos atacantes.',
        features: ['Análise de vulnerabilidades', 'Teste de invasão controlado', 'Relatório detalhado']
      },
      websites: {
        title: 'Sites & Landing Pages',
        description: 'Criação de sites institucionais e landing pages com foco em conversão e segurança desde o design até o deploy.',
        features: ['Design moderno e responsivo', 'Performance e SEO otimizados', 'Hardening de segurança e HTTPS']
      },
      development: {
        title: 'Desenvolvimento Seguro',
        description: 'Criação de aplicações web e mobile com segurança integrada desde o início.',
        features: ['Código seguro', 'Revisão de segurança', 'Testes automatizados']
      },
      audit: {
        title: 'Auditoria de Segurança',
        description: 'Análise completa de infraestrutura, código e processos de segurança.',
        features: ['Análise de infraestrutura', 'Revisão de código', 'Compliance']
      },
      consulting: {
        title: 'Consultoria',
        description: 'Orientação estratégica para implementar cultura de segurança na sua empresa.',
        features: ['Estratégia de segurança', 'Treinamento de equipe', 'Gestão de riscos']
      },
      whatIncludes: 'O que inclui:',
      learnMore: 'Saiba Mais',
      requestQuote: 'Solicitar Orçamento',
      talkSpecialist: 'Falar com Especialista'
    },
    // Pentest Page
    pentest: {
      badge: 'Testes de Intrusão Profissionais',
      title: 'Testes de Intrusão',
      subtitle: 'Identifique vulnerabilidades antes que hackers as encontrem. Testes de intrusão profissionais para proteger seu negócio.',
      whatIncludes: 'O Que Inclui Nossos Testes de Intrusão',
      whatIncludesSubtitle: 'Segurança completa em todas as camadas',
      features: {
        analysis: {
          title: 'Análise de Vulnerabilidades',
          description: 'Varredura completa de sistemas para identificar falhas de segurança'
        },
        invasion: {
          title: 'Teste de Invasão',
          description: 'Simulação de ataques reais em ambiente controlado'
        },
        report: {
          title: 'Relatório Detalhado',
          description: 'Documentação completa com todas as vulnerabilidades encontradas'
        },
        risk: {
          title: 'Classificação de Riscos',
          description: 'Priorizamos as ameaças por nível de criticidade'
        }
      },
      methodology: 'Nossa Metodologia',
      methodologySubtitle: 'Processo estruturado e comprovado',
      steps: {
        recon: { title: 'Reconhecimento', description: 'Coleta de informações sobre o alvo' },
        mapping: { title: 'Mapeamento', description: 'Identificação de possíveis pontos de entrada' },
        exploitation: { title: 'Exploração', description: 'Tentativa controlada de exploração de vulnerabilidades' },
        documentation: { title: 'Documentação', description: 'Relatório completo com recomendações' }
      },
      ctaTitle: 'Proteja Sua Empresa Hoje',
      ctaSubtitle: 'Solicite um pentest e descubra suas vulnerabilidades antes dos atacantes',
      ctaButton: 'Solicitar Orçamento'
    },
    // Secure Development Page
    secureDev: {
      badge: 'Desenvolvimento Seguro',
      title: 'Desenvolvimento Seguro',
      subtitle: 'Criamos aplicações web, mobile e landing pages com segurança integrada desde o início.',
      differential: 'Nosso Diferencial',
      differentialSubtitle: 'Segurança em cada etapa do desenvolvimento',
      features: {
        code: { title: 'Código Seguro', description: 'Desenvolvimento seguindo as melhores práticas de segurança desde a primeira linha' },
        protection: { title: 'Proteção Integrada', description: 'Segurança implementada em todas as camadas da aplicação' },
        performance: { title: 'Performance', description: 'Otimização sem comprometer a segurança' },
        encryption: { title: 'Criptografia', description: 'Proteção de dados sensíveis com criptografia de ponta' },
        cicd: { title: 'CI/CD Seguro', description: 'Pipeline de desenvolvimento com testes de segurança automatizados' },
        testing: { title: 'Testes Rigorosos', description: 'Testes de segurança e validação antes de cada deploy' }
      },
      technologies: 'Tecnologias',
      technologiesSubtitle: 'Stack moderno e seguro',
      techStack: {
        frontend: 'Frontend',
        backend: 'Backend',
        database: 'Database',
        cloud: 'Cloud',
        devops: 'DevOps',
        auth: 'Authentication'
      },
      process: 'Processo de Desenvolvimento',
      processSubtitle: 'Da ideia ao lançamento seguro',
      processSteps: {
        planning: { title: 'Planejamento', description: 'Análise de requisitos e definição de arquitetura segura' },
        development: { title: 'Desenvolvimento', description: 'Código limpo e seguro seguindo OWASP guidelines' },
        testing: { title: 'Testes', description: 'Testes unitários, integração e segurança automatizados' },
        deploy: { title: 'Deploy', description: 'Implantação segura com monitoramento contínuo' }
      },
      ctaTitle: 'Vamos Construir Algo Seguro Juntos',
      ctaSubtitle: 'Entre em contato e transforme sua ideia em realidade com segurança garantida',
      ctaButton: 'Iniciar Projeto'
    },
    // About Page
    about: {
      title: 'Sobre a Software Secure',
      subtitle: 'Somos uma empresa especializada em cibersegurança, dedicada a proteger negócios contra ameaças digitais e desenvolver soluções seguras desde o início.',
      mission: 'Nossa Missão',
      missionText1: 'Priorizamos a segurança desde o início até o fim de cada projeto. Acreditamos que segurança não é um recurso adicional, mas sim um requisito fundamental.',
      missionText2: 'Com mais de 15 anos de experiência, já ajudamos centenas de empresas a proteger seus ativos digitais e construir soluções seguras.',
      values: 'Nossos Valores',
      valuesSubtitle: 'O que nos guia em cada projeto',
      valuesList: {
        security: { title: 'Segurança em Primeiro Lugar', description: 'Nunca comprometemos a segurança por velocidade ou custo' },
        team: { title: 'Equipe Especializada', description: 'Profissionais certificados e com anos de experiência' },
        excellence: { title: 'Excelência Técnica', description: 'Utilizamos as melhores práticas e tecnologias do mercado' },
        results: { title: 'Foco em Resultados', description: 'Comprometidos com o sucesso e segurança dos nossos clientes' }
      },
      stats: {
        projects: 'Projetos Concluídos',
        experience: 'Anos de Experiência',
        satisfaction: 'Satisfação dos Clientes',
        support: 'Suporte Disponível'
      }
    },
    // Cases Page
    cases: {
      title: 'Cases de Sucesso',
      subtitle: 'Conheça alguns projetos onde fizemos a diferença em segurança',
      client: 'Cliente:',
      results: 'Resultados:',
      casesList: {
        ecommerce: {
          title: 'Proteção de E-commerce contra Ataques',
          client: 'ShopSecure',
          category: 'Pentest',
          description: 'Identificamos e corrigimos 15 vulnerabilidades críticas em plataforma de e-commerce.',
          results: ['15 vulnerabilidades corrigidas', '100% de conformidade PCI-DSS', 'Zero incidentes pós-implementação']
        },
        banking: {
          title: 'App Bancário Seguro',
          client: 'FinanceApp',
          category: 'Desenvolvimento Seguro',
          description: 'Desenvolvemos aplicativo bancário com segurança de ponta a ponta.',
          results: ['Lançamento sem vulnerabilidades', 'Certificação ISO 27001', '500k+ downloads seguros']
        },
        saas: {
          title: 'Auditoria de Segurança em SaaS',
          client: 'CloudTech',
          category: 'Auditoria',
          description: 'Auditoria completa de segurança em plataforma SaaS.',
          results: ['23 vulnerabilidades encontradas', 'Tempo de resposta: 48h', 'Certificação SOC 2']
        },
        corporate: {
          title: 'Website Corporativo Ultra-Seguro',
          client: 'GlobalCorp',
          category: 'Website',
          description: 'Website corporativo com proteção contra DDoS e WAF implementado.',
          results: ['WAF personalizado', 'Uptime 99.99%', 'Zero ataques bem-sucedidos']
        }
      }
    },
    // Blog Page
    blog: {
      title: 'Blog de Cibersegurança',
      subtitle: 'Artigos, dicas e insights sobre segurança digital',
      search: 'Buscar artigos...',
      readMore: 'Ler mais',
      author: 'Autor'
    },
    // Contact Page
    contact: {
      title: 'Entre em Contato',
      subtitle: 'Estamos prontos para proteger seu negócio. Fale com nossos especialistas.',
      talkToUs: 'Fale Conosco',
      talkToUsText: 'Nossa equipe está pronta para ajudar você a proteger seu negócio. Entre em contato e receba uma consultoria gratuita.',
      email: 'E-mail',
      phone: 'Telefone',
      location: 'Localização',
      businessHours: 'Horário de Atendimento',
      monday: 'Segunda - Sexta',
      mondayHours: '9h - 18h',
      saturday: 'Sábado',
      saturdayHours: '9h - 13h',
      sunday: 'Domingo',
      closed: 'Fechado',
      sendMessage: 'Envie uma Mensagem',
      form: {
        name: 'Nome Completo',
        namePlaceholder: 'Seu nome',
        email: 'E-mail',
        emailPlaceholder: 'seu@email.com',
        phone: 'Telefone',
        phonePlaceholder: '(11) 99999-9999',
        company: 'Empresa',
        companyPlaceholder: 'Nome da empresa',
        service: 'Serviço de Interesse',
        servicePentest: 'Testes de Intrusão',
        serviceDevelopment: 'Desenvolvimento Seguro',
        serviceAudit: 'Auditoria de Segurança',
        serviceConsulting: 'Consultoria',
        serviceOther: 'Outro',
        message: 'Mensagem',
        messagePlaceholder: 'Conte-nos mais sobre suas necessidades...',
        submit: 'Enviar Mensagem',
        submitting: 'Enviando...',
        success: 'Mensagem enviada com sucesso! Entraremos em contato em breve.',
        error: 'Erro ao enviar mensagem. Tente novamente.'
      }
    },
    // Footer
    footer: {
      tagline: 'Priorizamos a segurança do início ao fim de cada projeto',
      rights: 'Todos os direitos reservados',
      services: 'Serviços',
      company: 'Empresa',
      resources: 'Recursos',
      securityPriority: 'Segurança é nossa prioridade'
    },
    // Common
    common: {
      companies: 'Empresas que confiam em nós',
      clients: 'O Que Dizem Nossos Clientes',
      clientsSubtitle: 'Confiança conquistada através de resultados',
      manifesto: 'Segurança do Início ao Fim',
      manifestoText: 'Nós priorizamos a segurança desde o início até o fim de cada projeto. Nossa missão é proteger seu negócio contra ameaças cibernéticas reais.',
      finalCTA: 'Pronto para Proteger Seu Negócio?',
      finalCTASubtitle: 'Entre em contato e receba uma análise gratuita de segurança',
      finalCTAButton: 'Solicitar Consultoria Gratuita',
      heroStats: {
        secureProjects: 'Projetos Seguros',
        satisfaction: 'Satisfação',
        support: 'Suporte',
        yearsExperience: 'Anos de Experiência'
      },
      testimonials: [
        { quote: 'A Software Secure transformou nossa segurança digital. Os testes de intrusão identificaram vulnerabilidades críticas que nem sabíamos que existiam.', name: 'Marcos Aurelio', role: 'Diretor', company: 'JLM Esquadrias' },
        { quote: 'Desenvolvimento seguro desde o início. Nosso aplicativo foi lançado sem nenhuma vulnerabilidade de segurança.', name: 'Bruno Varelo', role: 'CEO', company: 'Clarilever' },
        { quote: 'Profissionais extremamente competentes. A auditoria de segurança foi detalhada e as recomendações muito práticas.', name: 'BarberBook Team', role: 'O melhor app de barbeiros do mundo', company: 'BarberBook' }
      ]
    }
  },
  en: {
    // Navigation
    nav: {
      home: 'Home',
      services: 'Services',
      pentest: 'Pentest',
      secureDev: 'Secure Development',
      about: 'About',
      cases: 'Cases',
      blog: 'Blog',
      contact: 'Contact'
    },
    // Hero
    hero: {
      title: 'Security from the first line of code to final deployment',
      subtitle: 'Secure websites, applications and landing pages, plus professional pentesting to protect your business from real cyber threats.',
      primaryCTA: 'Request Security Audit',
      secondaryCTA: 'Talk to a Specialist'
    },
    // Services
    services: {
      title: 'Our Services',
      subtitle: 'Complete cybersecurity solutions, intrusion testing and secure websites/apps to protect your business',
      pentest: {
        title: 'Pentest',
        description: 'Professional penetration testing to identify vulnerabilities before attackers.',
        features: ['Vulnerability analysis', 'Controlled invasion test', 'Detailed report']
      },
      websites: {
        title: 'Websites & Landing Pages',
        description: 'Creation of high-converting institutional websites and landing pages with security built in from design to deployment.',
        features: ['Modern responsive design', 'Performance and SEO optimization', 'Security hardening and HTTPS']
      },
      development: {
        title: 'Secure Development',
        description: 'Creating web and mobile applications with integrated security from the start.',
        features: ['Secure code', 'Security review', 'Automated testing']
      },
      audit: {
        title: 'Security Audit',
        description: 'Complete analysis of infrastructure, code and security processes.',
        features: ['Infrastructure analysis', 'Code review', 'Compliance']
      },
      consulting: {
        title: 'Consulting',
        description: 'Strategic guidance to implement security culture in your company.',
        features: ['Security strategy', 'Team training', 'Risk management']
      },
      whatIncludes: 'What includes:',
      learnMore: 'Learn More',
      requestQuote: 'Request Quote',
      talkSpecialist: 'Talk to Specialist'
    },
    // Pentest Page
    pentest: {
      badge: 'Professional Pentest',
      title: 'Penetration Testing',
      subtitle: 'Identify vulnerabilities before hackers find them. Professional pentest to protect your business.',
      whatIncludes: 'What Our Pentest Includes',
      whatIncludesSubtitle: 'Complete security across all layers',
      features: {
        analysis: {
          title: 'Vulnerability Analysis',
          description: 'Complete system scanning to identify security flaws'
        },
        invasion: {
          title: 'Invasion Test',
          description: 'Simulation of real attacks in controlled environment'
        },
        report: {
          title: 'Detailed Report',
          description: 'Complete documentation with all vulnerabilities found'
        },
        risk: {
          title: 'Risk Classification',
          description: 'We prioritize threats by criticality level'
        }
      },
      methodology: 'Our Methodology',
      methodologySubtitle: 'Structured and proven process',
      steps: {
        recon: { title: 'Reconnaissance', description: 'Gathering information about the target' },
        mapping: { title: 'Mapping', description: 'Identifying possible entry points' },
        exploitation: { title: 'Exploitation', description: 'Controlled attempt to exploit vulnerabilities' },
        documentation: { title: 'Documentation', description: 'Complete report with recommendations' }
      },
      ctaTitle: 'Protect Your Company Today',
      ctaSubtitle: 'Request a pentest and discover your vulnerabilities before attackers',
      ctaButton: 'Request Quote'
    },
    // Secure Development Page
    secureDev: {
      badge: 'Secure Development',
      title: 'Secure Development',
      subtitle: 'We create web, mobile and landing page applications with integrated security from the start.',
      differential: 'Our Differential',
      differentialSubtitle: 'Security at every stage of development',
      features: {
        code: { title: 'Secure Code', description: 'Development following security best practices from the first line' },
        protection: { title: 'Integrated Protection', description: 'Security implemented at all application layers' },
        performance: { title: 'Performance', description: 'Optimization without compromising security' },
        encryption: { title: 'Encryption', description: 'Sensitive data protection with cutting-edge encryption' },
        cicd: { title: 'Secure CI/CD', description: 'Development pipeline with automated security tests' },
        testing: { title: 'Rigorous Testing', description: 'Security testing and validation before each deploy' }
      },
      technologies: 'Technologies',
      technologiesSubtitle: 'Modern and secure stack',
      techStack: {
        frontend: 'Frontend',
        backend: 'Backend',
        database: 'Database',
        cloud: 'Cloud',
        devops: 'DevOps',
        auth: 'Authentication'
      },
      process: 'Development Process',
      processSubtitle: 'From idea to secure launch',
      processSteps: {
        planning: { title: 'Planning', description: 'Requirements analysis and secure architecture definition' },
        development: { title: 'Development', description: 'Clean and secure code following OWASP guidelines' },
        testing: { title: 'Testing', description: 'Unit, integration and automated security tests' },
        deploy: { title: 'Deploy', description: 'Secure deployment with continuous monitoring' }
      },
      ctaTitle: "Let's Build Something Secure Together",
      ctaSubtitle: 'Get in touch and turn your idea into reality with guaranteed security',
      ctaButton: 'Start Project'
    },
    // About Page
    about: {
      title: 'About Software Secure',
      subtitle: 'We are a company specialized in cybersecurity, dedicated to protecting businesses against digital threats and developing secure solutions from the start.',
      mission: 'Our Mission',
      missionText1: 'We prioritize security from start to finish of every project. We believe security is not an additional feature, but a fundamental requirement.',
      missionText2: 'With over 15 years of experience, we have helped hundreds of companies protect their digital assets and build secure solutions.',
      values: 'Our Values',
      valuesSubtitle: 'What guides us in each project',
      valuesList: {
        security: { title: 'Security First', description: 'We never compromise security for speed or cost' },
        team: { title: 'Specialized Team', description: 'Certified professionals with years of experience' },
        excellence: { title: 'Technical Excellence', description: 'We use the best practices and technologies in the market' },
        results: { title: 'Focus on Results', description: 'Committed to the success and security of our clients' }
      },
      stats: {
        projects: 'Completed Projects',
        experience: 'Years of Experience',
        satisfaction: 'Client Satisfaction',
        support: 'Support Available'
      }
    },
    // Cases Page
    cases: {
      title: 'Success Stories',
      subtitle: 'Learn about some projects where we made a difference in security',
      client: 'Client:',
      results: 'Results:',
      casesList: {
        ecommerce: {
          title: 'E-commerce Protection Against Attacks',
          client: 'ShopSecure',
          category: 'Pentest',
          description: 'We identified and fixed 15 critical vulnerabilities in e-commerce platform.',
          results: ['15 vulnerabilities fixed', '100% PCI-DSS compliance', 'Zero post-implementation incidents']
        },
        banking: {
          title: 'Secure Banking App',
          client: 'FinanceApp',
          category: 'Secure Development',
          description: 'We developed banking app with end-to-end security.',
          results: ['Launch without vulnerabilities', 'ISO 27001 certification', '500k+ secure downloads']
        },
        saas: {
          title: 'SaaS Security Audit',
          client: 'CloudTech',
          category: 'Audit',
          description: 'Complete security audit on SaaS platform.',
          results: ['23 vulnerabilities found', 'Response time: 48h', 'SOC 2 certification']
        },
        corporate: {
          title: 'Ultra-Secure Corporate Website',
          client: 'GlobalCorp',
          category: 'Website',
          description: 'Corporate website with DDoS protection and implemented WAF.',
          results: ['Custom WAF', 'Uptime 99.99%', 'Zero successful attacks']
        }
      }
    },
    // Blog Page
    blog: {
      title: 'Cybersecurity Blog',
      subtitle: 'Articles, tips and insights about digital security',
      search: 'Search articles...',
      readMore: 'Read more',
      author: 'Author'
    },
    // Contact Page
    contact: {
      title: 'Get in Touch',
      subtitle: 'We are ready to protect your business. Talk to our specialists.',
      talkToUs: 'Talk to Us',
      talkToUsText: 'Our team is ready to help you protect your business. Get in touch and receive free consultation.',
      email: 'Email',
      phone: 'Phone',
      location: 'Location',
      businessHours: 'Business Hours',
      monday: 'Monday - Friday',
      mondayHours: '9am - 6pm',
      saturday: 'Saturday',
      saturdayHours: '9am - 1pm',
      sunday: 'Sunday',
      closed: 'Closed',
      sendMessage: 'Send a Message',
      form: {
        name: 'Full Name',
        namePlaceholder: 'Your name',
        email: 'Email',
        emailPlaceholder: 'your@email.com',
        phone: 'Phone',
        phonePlaceholder: '(11) 99999-9999',
        company: 'Company',
        companyPlaceholder: 'Company name',
        service: 'Service of Interest',
        servicePentest: 'Intrusion Testing',
        serviceDevelopment: 'Secure Development',
        serviceAudit: 'Security Audit',
        serviceConsulting: 'Consulting',
        serviceOther: 'Other',
        message: 'Message',
        messagePlaceholder: 'Tell us more about your needs...',
        submit: 'Send Message',
        submitting: 'Sending...',
        success: 'Message sent successfully! We will contact you soon.',
        error: 'Error sending message. Please try again.'
      }
    },
    // Footer
    footer: {
      tagline: 'We prioritize security from start to finish of every project',
      rights: 'All rights reserved',
      services: 'Services',
      company: 'Company',
      resources: 'Resources',
      securityPriority: 'Security is our priority'
    },
    // Common
    common: {
      companies: 'Companies that trust us',
      clients: 'What Our Clients Say',
      clientsSubtitle: 'Trust earned through results',
      manifesto: 'Security from Start to Finish',
      manifestoText: 'We prioritize security from start to finish of every project. Our mission is to protect your business against real cyber threats.',
      finalCTA: 'Ready to Protect Your Business?',
      finalCTASubtitle: 'Get in touch and receive a free security analysis',
      finalCTAButton: 'Request Free Consultation',
      heroStats: {
        secureProjects: 'Secure Projects',
        satisfaction: 'Satisfaction',
        support: 'Support',
        yearsExperience: 'Years of Experience'
      },
      testimonials: [
        { quote: 'Software Secure transformed our digital security. Intrusion testing identified critical vulnerabilities we did not even know existed.', name: 'Marcos Aurelio', role: 'Director', company: 'JLM Esquadrias' },
        { quote: 'Secure development from the start. Our app was launched with zero security vulnerabilities.', name: 'Bruno Varelo', role: 'CEO', company: 'Clarilever' },
        { quote: 'Extremely competent professionals. The security audit was thorough and the recommendations very practical.', name: 'BarberBook Team', role: 'The best barber app in the world', company: 'BarberBook' }
      ]
    }
  }
};
